"use strict";

class SSAlertService {

    constructor($rootScope, $timeout) {
        const self = this;

        self.$rootScope = $rootScope;
        self.$timeout = $timeout;

        self.TYPE_SUCCESS = 'success';
        self.TYPE_INFO = 'info';
        self.TYPE_WARNING = 'warning';
        self.TYPE_DANGER = 'danger';

        self.alertTimeout = null;

        self.clear();
    }

    clear() {
        const self = this;

        self.type = null;
        self.title = null;
        self.message = null;
    }

    show(type, title, message) {
        const self = this;

        if (title && !message) {
            message = title;
            title = null;
        }

        if (!(type && message)) return;

        if (!title) {
            if (type == self.TYPE_SUCCESS) {
                title = 'Success!';
            } else if (type == self.TYPE_INFO) {
                title = 'Info!';
            } else if (type == self.TYPE_WARNING) {
                title = 'Warning!';
            } else if (type == self.TYPE_DANGER) {
                title = 'Oops!';
            }
        }

        // WEB-4314: a success toast shown moments earlier leaves a pending
        // 7s timeout that nulls `message`. Without cancelling it, an info /
        // warning / danger alert raised inside that window is wiped off the
        // screen by the older toast's own expiry.
        if (typeof successAlertTimeout !== 'undefined' && successAlertTimeout) {
            self.$timeout.cancel(successAlertTimeout);
            successAlertTimeout = null;
            jQuery('#__ss_success_alert_message__').hide();
        }

        self.type = type;
        self.title = title;
        self.message = message;

        $('html,body').animate({ scrollTop: jQuery('#__ss_alert_message__').offset().top }, 'slow');
    }

    showPop(type, title, message) {
        const self = this;

        if (title && !message) {
            message = title;
            title = null;
        }

        if (!(type && message)) return;

        if (!title) {
            if (type == self.TYPE_SUCCESS) {
                title = 'Success!';
            } else if (type == self.TYPE_INFO) {
                title = 'Info!';
            } else if (type == self.TYPE_WARNING) {
                title = 'Warning!';
            } else if (type == self.TYPE_DANGER) {
                title = 'Oops!';
            }
        }

        self.type = type;
        self.titlePop = title;
        self.messagePop = message;
    }

    showSuccess(type, title, message) {
        const self = this;

        if (title && !message) {
            message = title;
            title = null;
        }

        if (!(type && message)) return;

        if (!title && type === self.TYPE_SUCCESS) {
            title = 'Success!';
        }

        self.type = type;
        self.title = title;
        self.message = message;

        jQuery('#__ss_success_alert_message__').show();
        if (successAlertTimeout) {
            self.$timeout.cancel(successAlertTimeout); // Clear exising timeout
        }
        successAlertTimeout = self.$timeout(function() { // Hide success message after 7s
            self.message = null;
            jQuery('#__ss_success_alert_message__').hide();
        }, 7000)
    }

    success(title, message) {
        let self = this;

        if (successAlertTimeout) { // If Success Toast message already shown then clear it before showing new one.
            self.message = null;
            jQuery('#__ss_success_alert_message__').hide();
            self.$timeout.cancel(successAlertTimeout); // Clear exising timeout
            self.$timeout(function() { // Wait for angular render cycle to finish before showing success message again
                self.showSuccess(self.TYPE_SUCCESS, title, message);
            }, 0)
        } else {
            this.showSuccess(this.TYPE_SUCCESS, title, message);
        }
    }

    successPop(title, message) {
        this.showPop(this.TYPE_SUCCESS, title, message);
    }

    info(title, message) {
        this.show(this.TYPE_INFO, title, message);
    }

    warning(title, message) {
        this.show(this.TYPE_WARNING, title, message);
    }

    danger(title, message) {
        this.show(this.TYPE_DANGER, title, message);
    }

    parseAndDisplayError(response) {
        const self = this;

        console.log(response);

        let code = null;

        if (response) {
            if (response.code) {
                code = response.code;
            } else if (response.data && response.data.code) {
                code = response.data.code;
            }
        }

        if (!code) return;

        self.$rootScope.single_login_error = false;
        
        if (code == 401) {
            if (response.sub_code == 401001 || response.sub_code == 401003 || response.sub_code == 401004) {
                self.$rootScope.$broadcast('UserLoginRequiredEvent');
                self.danger('Opps!', 'You have been logged out from this session. Please login to continue.');
                self.$rootScope.single_login_error = true;
            } else {
                self.danger('Unauthorised!', 'You cannot perform this action. Please make sure you are logged in and has required permissions.');
            }
        } else if (code == 403) {
            self.danger('Forbidden!', 'This action is not allowed.');
        } else if (code == 404) {
            self.danger('Not Found!', 'The data/action request you are making is not available.');
        } else if (code == 405) {
            self.danger('Not Allowed!', 'Something is really not right. Please contact support.');
        } else if (code == 409) {
            self.danger('Conflict!', 'Another entry already exists with this value.');
        } else if (code == 412) {
            self.danger('Invalid Params!', 'Please fill-in the valid information.');
        } else {
            self.danger('Oops!', 'Something went wrong. Please contact support.');
        }

        if (response.data && response.data.message) {
            self.warning('Warning!', response.data.message);
        }
    }

    /**
     * Display the API's descriptive error message when the server provided one,
     * otherwise fall back to the generic code-based handling.
     *
     * @remarks
     * WEB-3647: HttpService.makeErrorObject() places the API's top-level
     * `message` on `response.message`. parseAndDisplayError() only emits a
     * generic code-based toast (e.g. a 412 shows "Invalid Params! Please
     * fill-in the valid information.") and looks for a descriptive message at
     * `response.data.message` — the doubly-nested payload, which is almost
     * always undefined — so the server's real message was silently dropped.
     * This helper surfaces `response.message` directly so the user sees the
     * actual reason (e.g. a duplicate refund tracking number). Auth failures
     * (401) are still delegated to parseAndDisplayError so the session-expiry /
     * login-required side-effects are preserved, and the internal placeholder
     * messages set by makeErrorObject when the server gives no message are
     * treated as generic.
     *
     * @param {Error|Object} response - Rejected HttpService response object.
     * @returns {void}
     */
    parseAndDisplayServerError(response) {
        const self = this;

        let serverMessage = response && response.message;
        let isGenericMessage = !serverMessage
            || serverMessage === 'Invalid data, no success status found'
            || serverMessage === 'Success status is false from server ';

        if (response && response.code != 401 && !isGenericMessage) {
            self.danger('Oops!', serverMessage);
            return;
        }

        self.parseAndDisplayError(response);
    }
}

SSAlertService.$inject = ['$rootScope', '$timeout'];
app.service('SSAlertService', SSAlertService);